import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import TerminalService from "../../app/data/terminal-details/terminalService";
import { initialTerminalState } from "./TerminalDetailsState";
import { UpdateAddress } from "../../app/data/terminal-details/models";

const terminalService = TerminalService.getInstance();

export const updateAddressSlice = createSlice({
    name: "updateAddress",
    initialState: initialTerminalState,
    reducers: {
        loading: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = null;
        },
        setUpdateAddress: (state, { payload }) => {
            state.data = payload;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.errorMessage = null;
        },
        error: (state, { payload }) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.errorMessage = payload;
        }
    },
});

export const {
    loading,
    setUpdateAddress,
    error
} = updateAddressSlice.actions;

export const updateAddressSelector = (state: IState) => state.updateAddress;

// update terminal address by address id
export const updateTerminalAddressById = (terminalNumber: string, addressId: string, data: UpdateAddress, onSuccess?: () => void, onError?: (message: string | object) => void): AppThunk => async (dispatch) => {
    if (!addressId) return
    dispatch(loading());
    const response = await terminalService.updateTerminalAddressById(terminalNumber, addressId, data);
    if (response.ok()) {
        dispatch(setUpdateAddress(response.data));
        onSuccess?.();
    } else {
        dispatch(error(response.getError()));
        if(typeof response.getError() === "string" && response.getError() !== "")
            onError?.(response?.getError() || "Error! Please try again later...");
        else
            onError?.("Error! Please try again later...");
    }
};

const updateAddressReducer = updateAddressSlice.reducer;
export default updateAddressReducer;
